document.addEventListener('DOMContentLoaded', function(){
  const filter = document.getElementById('main-collection-filters');
  const grid   = document.getElementById('ProductGridContainer');
  const offset = filter.getBoundingClientRect().top + window.pageYOffset;
  let   lastY  = window.pageYOffset;
  const mql    = window.matchMedia('(max-width: 749px)');

  mql.addEventListener('change', e => {
    if (!e.matches) {
      filter.classList.remove('is-fixed-down','is-fixed-up');
      grid.style.marginTop = '0';
    }
  });

  window.addEventListener('scroll', () => {
    if (!mql.matches) return;

    const y      = window.pageYOffset;
    const isDown = y > lastY;

    if (y > offset) {
      if (isDown) {
        filter.classList.add('is-fixed-down');
        filter.classList.remove('is-fixed-up');
      } else {
        filter.classList.add('is-fixed-up');
        filter.classList.remove('is-fixed-down');
      }
      grid.style.marginTop = filter.offsetHeight + 'px';
    } else {
      filter.classList.remove('is-fixed-down','is-fixed-up');
      grid.style.marginTop = '0';
    }

    lastY = y;
  });
});
